<template>
  <WoAppWrapper>
    <template slot-scope="{ slottedLabels }">
      {{ loadLabels(slottedLabels) }}
      <el-container>
        <el-main>
          <div class="price-calculator">
            <el-row>
              <el-col :lg="12" :xs="24" :sm="12">
                <div class="price-calculator-heading">
                  <Title
                    :text="pcLabels.pageTitle"
                    size="primary"
                    color="black"
                    class="price-calculator-heading__title"
                  ></Title>
                </div>
                <div class="price-calculator-content">
                  <div class="price-calculator-content__block">
                    <div class="price-calculator-content__selects-wrapper">
                      <CitiesSelect
                        :placeholder="pcLabels.selectCityPlaceholder"
                        :cities="cities"
                        :selected-city="selectedCity"
                        :select-city="handleSelectCity"
                        class="price-calculator-content__select"
                      ></CitiesSelect>
                    </div>
                  </div>
                  <div
                    class="price-calculator-content__block"
                    v-if="isCitySelected"
                  >
                    <Title
                      :text="pcLabels.selectModelTitle"
                      size="primary"
                      color="black"
                      class="price-calculator-heading__title"
                    ></Title>
                    <div class="price-calculator-content__selects-wrapper">
                      <div class="vehicle-cards-container">
                        <div
                          class="vehicle-card"
                          @click="handleSelectType('car')"
                          :class="{
                            active: selectedType === 'car'
                          }"
                        >
                          <img
                            :src="getCarImg"
                            class="vehicle-card-img"
                            alt=""
                          />
                          <p>Auto</p>
                        </div>
                        <div
                          class="vehicle-card"
                          @click="handleSelectType('scooter')"
                          :class="{
                            active: selectedType === 'scooter'
                          }"
                        >
                          <img
                            :src="getScooterImg"
                            class="vehicle-card-img"
                            alt=""
                          />
                          <p>Scooter/Moto</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="price-calculator-content__block"
                    v-if="isTypeSelected && selectedType === 'car'"
                  >
                    <div
                      class="price-calculator-content__selects-wrapper_vehicle"
                    >
                      <BrandsSelect
                        :placeholder="pcLabels.selectBrandPlaceholder"
                        :brands="brands"
                        :selected-brand="selectedBrand"
                        :select-brand="handleSelectBrand"
                        class="price-calculator-content__select_vehicle"
                      ></BrandsSelect>
                      <ModelsSelect
                        :placeholder="pcLabels.selectModelPlaceholder"
                        :brand-models="brandModels"
                        :selected-model="selectedModel"
                        :select-model="handleSelectModel"
                        class="price-calculator-content__select_vehicle"
                      ></ModelsSelect>
                    </div>
                  </div>
                  <div
                    class="price-calculator-content__block"
                    v-if="
                      (isModelSelected && selectedType === 'car') ||
                        selectedType === 'scooter'
                    "
                  >
                    <div
                      class="price-calculator-content__selects-wrapper price-calculator-content__selects-wrapper--wrapped"
                    >
                      <Services
                        :services-accordions="servicesAccordions"
                        :selected-services="selectedServices"
                        :select-service="handleServiceSelection"
                        :toggle-service-accordion="toggleServiceAccordion"
                        :should-show-services="
                          !!selectedBrand && !!selectedModel
                        "
                        :isOptionalServiceTitleVisible="false"
                        :isDisabled="false"
                        :labels="pcLabels"
                        class="price-calculator-content__accordion"
                      ></Services>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :lg="12" :xs="24" :sm="12">
                <div class="result-card" v-if="!!foundPackage">
                  <img :src="getVehicleImg" class="result-card-img" alt="" />
                  <div class="title-div">
                    <p class="title">{{ vehicleDescription }}</p>
                    <p class="title">{{ packageVehicleType }}</p>
                  </div>
                  <div>
                    <p class="title-blue">{{ packageAmount }}</p>
                    <p>{{ packageDuration }}</p>
                    <p>{{ durationWarning }}</p>
                  </div>
                  <p class="title-search" @click="resetSearch">
                    {{ pcLabels.resetSearch }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-container>
    </template>
  </WoAppWrapper>
</template>
<script>
import WoAppWrapper from '@/components/shared/WoAppWrapper';
import Title from '@/components/shared/Title';
import CitiesSelect from '@/components/PriceCalculator/CitiesSelect.vue';
import BrandsSelect from '@/components/Booking/BrandsSelect/BrandsSelect.vue';
import ModelsSelect from '@/components/Booking/ModelsSelect/ModelsSelect.vue';
import Services from '@/components/Booking/Services/Services.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {
  getTotalAmount,
  formatPrice,
  getVehicleImgByCarId,
  getCarDefaultImg,
  getScooterDefaultImg
} from '@/utils/generic';
export default {
  data: function() {
    return {
      scooterModel: 'a71b70f1-207b-457e-b72e-35351e397c6c',
      isCitySelected: false,
      isTypeSelected: false,
      isModelSelected: false,
      areServicesSelected: false,
      togglePremiumServicesModal: false,
      selectedCity: {},
      selectedType: {},
      selectedBrand: {},
      selectedModel: {},
      selectedServices: [],
      foundPackage: null,
      labels: {},
      genericLabels: {}
    };
  },
  async mounted() {
    this.$recaptchaLoaded().then(async () => {
      await this.getCities(null);
      await this.getBrands();
    });
  },
  components: {
    WoAppWrapper,
    Title,
    CitiesSelect,
    BrandsSelect,
    ModelsSelect,
    Services
  },
  computed: {
    pcLabels() {
      return this.labels;
    },
    durationWarning() {
      return this.labels.durationWarningTitle;
    },
    totalAmount() {
      return `${formatPrice(getTotalAmount(this.selectedServices, 0))} €`;
    },
    getVehicleImg() {
      return getVehicleImgByCarId(
        this.foundPackage.vehicleTypeName,
        this.foundPackage.vehiclePropertyName
      );
    },
    getCarImg() {
      return getCarDefaultImg();
    },
    getScooterImg() {
      return getScooterDefaultImg();
    },
    vehicleDescription() {
      const brand = this.selectedBrand?.name ? this.selectedBrand.name : '';
      const model = this.selectedModel?.name ? this.selectedModel.name : '';
      const type = `${this.foundPackage.vehicleTypeName} ${this.foundPackage.vehiclePropertyName}`;

      return `${brand} ${model}`;
    },
    packageDuration() {
      const washingDurationMessage = this.labels.washingDurationMessage;
      return this.foundPackage?.executionTime
        ? washingDurationMessage.replace(
            '{0}',
            this.foundPackage.executionTime || 0
          )
        : '';
    },
    packageAmount() {
      return this.foundPackage?.packagePricePrice?.price
        ? `${formatPrice(
            this.foundPackage.packagePricePrice.price +
              (this.foundPackage.packagePricePrice?.vat || 0)
          )} €`
        : '';
    },
    packageVehicleType() {
      return `${this.foundPackage.vehicleTypeName} ${this.foundPackage.vehiclePropertyName}`;
    },
    ...mapGetters('priceCalculator', [
      'brands',
      'brandModels',
      'services',
      'packages',
      'servicesAccordions',
      'cities'
    ]),
    ...mapGetters('vehicles', ['vehicleTypes'])
  },
  methods: {
    resetSearch() {
      this.selectedCity = {};
      this.isCitySelected = false;
      this.isTypeSelected = false;
      this.isModelSelected = false;
      this.areServicesSelected = false;
      this.selectedType = {};
      this.selectedBrand = {};
      this.selectedModel = {};
      this.selectedServices = [];
      this.foundPackage = null;

      window.scrollTo(0, 0);
    },
    loadLabels(slottedLabels) {
      this.genericLabels = slottedLabels?.generic || {};
      this.labels = slottedLabels?.priceCalculator || {};
    },
    handleSelectCity(city) {
      if (city && city.id) {
        this.selectedCity = city;
        this.isCitySelected = true;
      } else {
        this.selectedCity = {};
        this.isCitySelected = false;
      }

      this.isTypeSelected = false;
      this.isModelSelected = false;
      this.areServicesSelected = false;
      this.selectedType = {};
      this.selectedBrand = {};
      this.selectedModel = {};
      this.selectedServices = [];
      this.foundPackage = null;
    },
    async handleSelectType(type) {
      if (type) {
        this.selectedType = type;
        this.isTypeSelected = true;

        if (type === 'scooter') {
          await this.getPackagesAndServices({
            vehicleModelId: this.scooterModel,
            currentCountryId: this.selectedCity.country.id,
            selectedCityId: this.selectedCity.id,
            labels: this.labels
          });
        }
      } else {
        this.selectedType = {};
        this.isTypeSelected = false;
      }

      this.isModelSelected = false;
      this.areServicesSelected = false;
      this.selectedBrand = {};
      this.selectedModel = {};
      this.selectedServices = [];
      this.foundPackage = null;
    },
    async handleSelectBrand(brand) {
      if (brand && brand.id) {
        this.selectedBrand = brand;
        await this.getBrandModels(brand.id);
      } else {
        this.selectedBrand = {};
      }

      this.isModelSelected = false;
      this.areServicesSelected = false;
      this.selectedModel = {};
      this.selectedServices = [];
      this.foundPackage = null;
    },
    handleServiceSelection(service) {
      // this.$gtag.event("service_selected");
      let serviceAccordion = this.servicesAccordions.find(
        x => x.option.id === service.id
      );
      serviceAccordion.isSelected = !serviceAccordion.isSelected;

      let filteredPackages = JSON.parse(JSON.stringify(this.packages));
      const selectedServices = this.servicesAccordions.filter(
        x => x.isSelected
      );
      selectedServices.forEach(service => {
        filteredPackages = filteredPackages.filter(p =>
          p.services.find(x => x.id === service.option.id)
        );
      });
      const foundPackage = filteredPackages.find(
        x => x.services.length === selectedServices.length
      );
      if (foundPackage) {
        this.foundPackage = foundPackage;
      } else if (selectedServices.length == 1) {
        this.$swal({
          icon: 'warning',
          title: this.labels.baseServicesMissingWarningTitle,
          html: this.labels.baseServicesMissingWarningBody
        });
        serviceAccordion.isSelected = !serviceAccordion.isSelected;
      } else if (selectedServices.length) {
        this.$swal({
          icon: 'warning',
          title: this.labels.noServicesCombinationWarningTitle,
          html: this.labels.noServicesCombinationWarningBody
        });
        serviceAccordion.isSelected = !serviceAccordion.isSelected;
      } else {
        this.foundPackage = null;
      }
    },
    async handleSelectModel(model) {
      if (model && model.id) {
        this.isModelSelected = true;
        this.selectedModel = model;
        await this.getPackagesAndServices({
          vehicleModelId: model.id,
          currentCountryId: this.selectedCity.country.id,
          selectedCityId: this.selectedCity.id,
          labels: this.labels
        });
      } else {
        this.selectedModel = {};
        this.isModelSelected = false;
      }

      this.areServicesSelected = false;
      this.selectedServices = [];
      this.foundPackage = null;
    },
    ...mapMutations('priceCalculator', ['toggleServiceAccordion']),
    ...mapActions('priceCalculator', [
      'getBrands',
      'getBrandModels',
      'getPackagesAndServices',
      'getCities'
    ]),
    ...mapActions('vehicles', ['getVehicleTypes'])
  }
};
</script>
<style lang="scss">
.vehicle-cards-container {
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }

  .vehicle-card {
    padding: 8px 16px;
    margin: 0 8px;
    background: #ffffff;
    box-shadow: 0px 1px 10px 0px #97979799;
    border: 1px solid #ffffff;
    border-radius: 16px;
    flex: 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    .vehicle-card-img {
      min-width: 120px !important;
      width: 120px !important;
    }
    &:first-child {
      margin-left: 0px;
    }
  }
  .active {
    border: 1px solid #195ef7;
    box-shadow: 0px 1px 10px 0px #00000033;
    background: linear-gradient(0deg, #d1dffd, #d1dffd),
      linear-gradient(0deg, #195ef7, #195ef7);
  }
  .vehicle-card:hover {
    background: linear-gradient(0deg, #d1dffd, #d1dffd),
      linear-gradient(0deg, #195ef7, #195ef7);
    border: 1px solid #195ef7;
    box-shadow: 0px 1px 10px 0px #00000033;
  }
}

.result-card {
  border-radius: 16px;
  background-color: white;
  box-shadow: 0px 1px 10px 0px #97979799;
  padding: 16px 32px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  z-index: 1000;
  position: fixed;

  @media (max-width: 768px) {
    bottom: 0;
    left: 0;
    margin: 8px 16px;
    z-index: 1000;
  }

  @media (max-width: 1199px) and (min-width: 768px) {
    max-width: 677px;
    left: 50%;
    margin-right: 45px;
    bottom: 0;
  }

  @media (min-width: 1199px) {
    top: auto;
    max-width: 677px;
    left: 50%;
    margin-right: 45px;
  }

  p {
    font-family: Poppins, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
  }

  .title-div {
    padding-top: 16px;
  }

  .title {
    font-weight: 600;
    font-size: 18px;
  }

  .title-blue {
    margin: 8px 0px;
    font-weight: 600;
    font-size: 18px;
    color: var(--blue__dark);
  }

  .title-search {
    margin: 8px 0px;
    font-weight: 600;
    font-size: 16px;
    color: var(--blue__dark);
    width: 100%;
    text-align: right;
  }

  img {
    min-width: 120px !important;
    width: 120px !important;
  }
}

.price-calculator {
  min-height: 100vh;
  margin: 0px;
  width: 100%;
  @media (min-width: 768px) {
    margin-top: 6em;
    padding: 0px 43px;
  }
  @media (max-width: 768px) {
    max-width: none;
    padding: 0px 16px;
  }
  box-sizing: border-box;

  &-heading {
    &__title {
      margin-bottom: 16px;
    }
  }
  &-content {
    &__block {
      width: 100%;
    }

    &__title {
      margin-bottom: 16px;
    }

    &__select {
      max-width: 307px;
      @media (max-width: 768px) {
        max-width: none;
        width: 100%;
      }
    }

    &__select_vehicle {
      min-width: 278px;
      @media (max-width: 768px) {
        max-width: none;
        width: 100%;
      }
      @media (min-width: 768px) {
        &:first-child {
          margin-right: 16px;
        }
      }
    }

    &__selects-wrapper_vehicle {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: wrap;
      margin-top: 16px;
    }
  }

  .service-accordion--wrapper {
    @media (min-width: 768px) {
      max-width: 350px;
    }
  }

  .multiselect,
  .multiselect__input,
  .multiselect__single {
    font-size: 16px !important;

    > * {
      border-color: white !important;
      font-size: 16px !important;
    }
  }

  // .multiselect__content-wrapper {
  //   min-height: 237px !important;
  //   max-height: 237px !important;
  // }
}
</style>
